import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PreSelectBox } from '../../../../../sg-kc-shared/constants/preSelectBox';
import { ReimporttargetLstInfo } from 'sg-api';

/**
 * 確定使用量再取込画面（検索結果）
 * @exports
 * @class Sgkc051dSearchResultComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc051d-search-result',
    templateUrl: './sgkc051d-search-result.component.html',
    styleUrl: './sgkc051d-search-result.component.scss',
})
export class Sgkc051dSearchResultComponent implements OnInit, OnDestroy, OnChanges {

    /** input用 ステータスのセレクトボックスデータ */
    @Input() inputStatusList: PreSelectBox[] = [];
    /** input用 供給地点特定番号 */
    @Input() inputSuppntSpno: string = '';
    /** 確定使用量再取込対象取得結果 */
    @Input() reimportTargetListResult: ReimporttargetLstInfo[] = [];

    /** 登録ボタン押下イベント */
    @Output() onClickRegistrationEvent = new EventEmitter<ReimporttargetLstInfo[]>();

    /** ステータスのセレクトボックスデータ */
    statusList: PreSelectBox[] = [];
    /** 検索結果表示用のステータスのセレクトボックスデータ */
    tableDataStatusList: PreSelectBox[] = [];
    /** 供給地点特定番号 */
    suppntSpno: string = '';

    /** 再取込グループ番号ごとにステータスコードを持つMap */
    reimpGrpNoAndStatusCodeMap: { [reimpGrpNo: string]: string } = {};
    /** htmlテーブルデータ */
    dataSourceSearchResultDisplay = new MatTableDataSource<ReimporttargetLstInfo>();
    /** 検索結果表示リスト */
    displayedColumnsCol: string[] = [
        'occureDate',
        'suppntSpno',
        'userMei',
        'targetYm',
        'usageStartdate',
        'usageEnddt',
        'empday',
        'empamt',
        'reimportTrnStatuscode',
        'biko'
    ];

    /** 
     * コンストラクタ
     * @memberof Sgkc051dSearchResultComponent
     */
    constructor() { }

    /** 
     * 初期処理
     * @memberof Sgkc051dSearchResultComponent
     */
    ngOnInit(): void { }

    /** 
     * コンポーネント破棄時の処理
     * @memberof Sgkc051dSearchResultComponent
     */
    ngOnDestroy(): void { }

    /**
     * 親コンポーネントから受け取った値を更新する。
     * @memberof Sgkc051dSearchResultComponent
     */
    ngOnChanges() {

        if (this.inputStatusList) {

            // コード変換したステータスを追加
            this.statusList = this.inputStatusList;

            // 取消済み、取込済みを除いたステータスリスト作成
            const targetStatusCodeList = ['0', '1', '2'];
            this.tableDataStatusList = this.statusList.filter(dto => targetStatusCodeList.includes(dto.value));
        }

        if (this.reimportTargetListResult) {

            // 確定使用量再取込対象 検索結果作成
            this.dataSourceSearchResultDisplay.data = this.reimportTargetListResult;

            // 再取込グループ番号ごとにMap作成
            this.reimpGrpNoAndStatusCodeMap = {};
            this.dataSourceSearchResultDisplay.data.forEach(resultData => {
                if (!this.reimpGrpNoAndStatusCodeMap[resultData.reimportGroupNo]) {
                    this.reimpGrpNoAndStatusCodeMap[resultData.reimportGroupNo] = resultData.reimportTrnStatuscode;
                }
            });
        }

        if (this.inputSuppntSpno) {

            // 供給地点特定番号を更新
            this.suppntSpno = this.inputSuppntSpno;
        }
    }

    /** 
     * 活性・非活性判定 
     * @memberof Sgkc051dSearchResultComponent
     */
    isReimportStatus(statusCode: string): boolean {
        return !this.tableDataStatusList.some(
            dto => dto.value === statusCode
        );
    }

    /**
     * ステータスコード更新処理 
     * @memberof Sgkc051dSearchResultComponent
     */
    onStatusChanged(reimportGroupNo: string, statusValue: string, event: any) {

        if (event.isUserInput) {

            // ステータスコードを更新
            this.dataSourceSearchResultDisplay.data.forEach(resultData => {
                if (resultData.reimportGroupNo === reimportGroupNo) {
                    resultData.reimportTrnStatuscode = statusValue;
                }
            });
        }
    }

    /** 
     * 登録ボタン押下処理 
     * @memberof Sgkc051dSearchResultComponent
     */
    onClickRegistration(): void {

        // 対象データ抽出
        const reimportTargetListResult: ReimporttargetLstInfo[] =
            this.dataSourceSearchResultDisplay.data
                .filter(resulData => this.tableDataStatusList.some(
                    dto => dto.value === resulData.reimportTrnStatuscode
                ));

        this.onClickRegistrationEvent.emit(reimportTargetListResult);
    }

    /** 
     * 供給地点特定番号編集処理
     * @memberof Sgkc051dSearchResultComponent
     */
    formattedText(suppntSpno: string): string {

        // スラッシュが含まれる場合、改行して表示
        if (suppntSpno.includes('/')) {
            return suppntSpno.slice(0, 18) + '\n' + suppntSpno.slice(18);
        }

        return suppntSpno;
    }

}
